import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    Typography,
    DialogTitle,
    Divider,
    Box,
    Popper,
    Autocomplete,
    TextField,
    Avatar
} from "@mui/material";
import { useTranslation } from "react-i18next";
import { makeStyles } from "@mui/styles";
import React, { useEffect, useState } from "react";
import { useDebouncedCallback } from 'use-debounce';
import proxyService from "../services/proxy.service";


const MIN_CHAR = 3

const useStyles = makeStyles({
    colorButton: {
        color: "red",
    }
});
const styles = {
    containerDialog: {
        padding: "0 30px"
    },
    popper: {
        maxWidth: "fit-content",
        overflow: "hidden"
    }
}
const SelectUser = (props) => {
    const { open: openDialog, setOpen: setOpenDialog, submit } = props
    const { t } = useTranslation()
    const [value, setValue] = useState(null);
    const [options, setOptions] = useState([]);
    const [proxyBy, setProxyBy] = useState({});
    const [word, setWord] = useState('')
    const [open, setOpen] = useState(false);
    const [isSearching, setIsSearching] = useState(false)

    const proxy = JSON.parse(localStorage.getItem("proxy"));
    const handleClose = () => {
        setOptions([])
        setValue(null)
        setOpenDialog(false)
    };
    const submits = () => {
        submit(value, proxyBy)
    };
    const classes = useStyles();
    let changeUser = (data) => {
        setValue(data)
    }

    const searchProxyUser = useDebouncedCallback(async (word) => {
        if (proxy === undefined || proxy === null || proxy === "") {
            word = word.trim();
            if (word && word.length >= MIN_CHAR) {
                setValue(null)
                setIsSearching(true)

                let values = []

                try {

                    const response = await proxyService.proxyEmployeeSearch(word)
                    if (response.success && response.data) {

                        setProxyBy(response?.data?.proxy_by !== undefined ? response?.data?.proxy_by : {})

                        values = response?.data?.proxy_target !== undefined ? response?.data?.proxy_target : []
                    } else {
                    }

                } catch (error) {
                    console.error(error)
                } finally {
                    setIsSearching(false)
                    setOptions(values);
                }

            } else {
                setOptions([]);
                setOpen(false);
            }
        }
    }, 500)


    useEffect(() => {
        if (openDialog) {
            /*
            setValue(null)

            if (proxy === undefined || proxy === null || proxy === "") {
                proxyService.proxyEmployee().then(
                    (response) => {
                        setProxyBy(response?.data?.proxy_by !== undefined ? response?.data?.proxy_by : {})
                        setOptions(response?.data?.proxy_target !== undefined ? response?.data?.proxy_target : []);
                    },
                ).catch((err) => {

                })
            }
            */
        }
    }, [openDialog]);

    useEffect(() => {

        if (word && !value) {
            searchProxyUser(word)
        }

    }, [word])

    return (
        <React.Fragment>
            <Dialog
                onBackdropClick={() => { return false }}
                open={openDialog}
                onClose={handleClose}
                fullWidth={true}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                sx={{ ".MuiPaper-root": { maxWidth: "630px" } }}
            >
                <DialogTitle id="form-add-dialog-title" sx={{}}>
                    <Typography fontWeight="600" fontSize={24} lineHeight={1.1} color="#404349">{t(`proxy.selectUser`)}</Typography>
                    <Divider sx={{ marginTop: "20px" }} />
                </DialogTitle>
                <DialogContent style={styles.containerDialog}>
                    <DialogContentText id="alert-dialog-description">
                        <Typography fontWeight="500" fontSize={18} lineHeight="26.91px" color="#404349" pb="9px">{t(`proxy.user`)}</Typography>
                        <Autocomplete
                            id="country-select-demo"
                            options={options}
                            // disableClearable
                            placeholder={'Type at least ' + MIN_CHAR + ' charactors to search'}
                            open={open}
                            defaultValue=""
                            displayEmpty
                            value={value}
                            getOptionLabel={(option) => option?.fullname !== undefined ? (option?.fullname + ' [' + option?.code + ']') : ""}
                            filterOptions={(options) => options}
                            onOpen={() => {
                                setOpen(true);
                            }}
                            onClose={() => {
                                setOpen(false);
                            }}
                            onInputChange={(event, newValue) => { setWord(newValue) }}
                            onChange={(event, newValue) => {
                                changeUser(newValue);
                            }}
                            onMouseDownCapture={(event) => {
                                event.stopPropagation();
                            }}
                            getOptionSelected={(option, value) => option.id === value.id}
                            renderOption={(props, option) => {
                                return (
                                    <Box component="li" {...props} sx={{ position: "relative", "::hover": { background: "#000 !important" }, "&:hover": { cursor: "pointer", background: "#5DA196 !important", ".MuiTypography-root": { color: "#fff !important" } } }}>
                                        <Avatar src={option?.photo} sx={{ width: 40, height: 40, mr: "15px" }} />
                                        <Box sx={{ width: "calc(100% - 55px)" }}>
                                            <Typography fontWeight="500" fontSize={18} lineHeight="26.91px" color="#404349" sx={{ width: "100%", "white-space": "nowrap", overflow: "hidden", "text-overflow": "ellipsis" }}>{option?.fullname} [{option?.code}]</Typography>
                                            <Typography fontWeight="400" fontSize={14} lineHeight="20.93px" color="#404349" sx={{ width: "100%", "white-space": "nowrap", overflow: "hidden", "text-overflow": "ellipsis" }}>{option?.position} {option?.organization !== undefined && option?.organization !== "" ? `(${option?.organization})` : " "}</Typography>
                                        </Box>
                                    </Box>
                                )
                            }}
                            noOptionsText={(MIN_CHAR > (word ?? '-').length) ? 'Type at least ' + MIN_CHAR + ' charactors to search' : (isSearching ? '' : t('label.notFund'))}
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    defaultValue=""
                                    displayEmpty
                                    size="small"
                                    placeholder={t(`proxy.selectUser`)}
                                    inputProps={{
                                        ...params.inputProps,
                                        autoComplete: 'new-password', // disable autocomplete and autofill
                                    }}
                                />
                            )}
                        />
                    </DialogContentText>
                </DialogContent>
                <DialogActions style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', marginBottom: 20, paddingTop: "50px" }}>
                    <Button onClick={handleClose} size="medium" variant="outlined" sx={{ width: '150px', marginRight: "10px" }} color="black">{t(`label.cancel`)}</Button>
                    <Button onClick={submits} disabled={value?.serial === undefined ? true : false} size="medium" variant="contained" sx={{ width: '150px' }}>{t(`label.confirm`)}</Button>
                </DialogActions>
            </Dialog>
        </React.Fragment>
    );
};
export default SelectUser;